(function(){
  'use strict';
  if(window.__ELMORE_REVERSE_LOTION_VARIANTS_V1__)return;
  window.__ELMORE_REVERSE_LOTION_VARIANTS_V1__=true;
  var DEAL='deal_LotionSerum26';
  var pending=false;
  function str(v){return String(v==null?'':v)}
  function id(v){var m=str(v&&v.id!=null?v.id:v).match(/(\d{6,24})(?:\D*)$/);return m?m[1]:''}
  function currentHandle(){return decodeURIComponent((location.pathname.split('/products/')[1]||'').split(/[?#/]/)[0]).toLowerCase()}
  function config(){return window.__DT_OFFER_MANAGER_V6_CFG__||null}
  function deal(){var c=config();return c&&Array.isArray(c.deals)?c.deals.find(function(d){return str(d.id)===DEAL}):null}
  function full(v){return Math.max(0,Number(v&&v.reference)||0,Number(v&&v.current)||0,Number(v&&v.price)||0)}
  function money(c){var n=Math.max(0,Math.round(Number(c)||0))/100;return 'PKR '+n.toLocaleString('en-PK',{minimumFractionDigits:n%1?2:0,maximumFractionDigits:2})}
  function mainProduct(d){
    var handle=currentHandle();
    return (d.mainProducts||[]).find(function(p){return str(p.handle).toLowerCase()===handle})||
      (d.mainProducts||[]).find(function(p){return str(p.handle).toLowerCase()===str(d.qualifierHandle).toLowerCase()})||null;
  }
  function summary(panel,d,mainVariant){
    var rows=panel.querySelectorAll('.dtm-bundle-row'),slots=d.bundleProducts||[];
    if(rows.length<slots.length)return;
    var base=0,selected=[];
    for(var i=0;i<slots.length;i++){
      var select=rows[i].querySelector('[data-dtm-bundle-select]');
      var v=select&&(slots[i].variants||[]).find(function(x){return id(x)===id(select.value)});
      if(!v)return;
      selected.push(v);base+=full(v);
    }
    var qInput=document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    var q=Math.max(1,parseInt(qInput&&qInput.value||'1',10)||1);
    var main=full(mainVariant),pct=Math.max(0,Number(d.bundleDiscount)||0);
    var reward=d.bundlePricingMode==='percent_off'?Math.round(base*(100-pct)/100):Math.max(0,Number(d.bundleFixedTotal)||0)-main;
    var total=(main+Math.max(0,reward))*q,original=(main+base)*q;
    var target=panel.querySelector('.dtm-summary,.dtm-bundle-summary');
    if(target)target.innerHTML='<span>Total bundle price ('+pct+'% OFF reward):</span><strong>'+money(total)+'</strong>'+(original>total?'<s>'+money(original)+'</s>':'');
  }
  function mount(panel){
    if(panel.querySelector('[data-elmore-lotion-variant]'))return;
    var d=deal();if(!d)return;
    var p=mainProduct(d);if(!p)return;
    var variants=(p.variants||[]).filter(function(v){return v&&v.available!==false});
    if(!variants.length)return;
    var grid=panel.querySelector('.dtm-v6-main-wrap');
    if(!grid)return;
    var holder=document.createElement('div');holder.className='elmore-lotion-variant';holder.dataset.elmoreLotionVariant='1';
    var label=document.createElement('label');label.textContent='STEP 1A  ·  Choose Lotion Size / Variant';
    var select=document.createElement('select');select.setAttribute('aria-label','Choose lotion variant for this deal');
    variants.forEach(function(v){var o=document.createElement('option');o.value=id(v);o.textContent=/^default title$/i.test(str(v.title))?str(p.title):str(v.title);select.appendChild(o)});
    label.appendChild(select);holder.appendChild(label);
    grid.insertAdjacentElement('afterend',holder);
    var keys=variants.map(id),nativeInput=document.querySelector('form[action*="/cart/add"] [name="id"]');
    var selected=id(nativeInput&&nativeInput.value),active=keys.includes(selected)?selected:keys[0];
    select.value=active;panel.dataset.dtmMainVariantId=active;
    function changed(){
      panel.dataset.dtmMainVariantId=select.value;
      var v=variants.find(function(x){return id(x)===select.value});
      if(v)summary(panel,d,v);
    }
    select.addEventListener('change',changed);
    changed();
  }
  function run(){
    pending=false;
    document.querySelectorAll('[data-dtm-panel][data-deal-id="'+DEAL+'"]').forEach(mount);
  }
  function queue(){if(pending)return;pending=true;requestAnimationFrame(run)}
  var css=document.createElement('style');css.id='elmore-reverse-lotion-variant-css';
  css.textContent='.elmore-lotion-variant{margin:10px 0 14px;padding:12px;border:1px solid #eadce4;border-radius:13px;background:#fff}.elmore-lotion-variant label{display:grid;gap:8px;color:#42303d;font-size:.64rem;font-weight:800;letter-spacing:.015em}.elmore-lotion-variant select{display:block;width:100%;min-height:43px;padding:9px 12px;border:1px solid #d9c8d2;border-radius:10px;color:#372b33;background:#fff;font-size:.68rem;cursor:pointer}';
  document.head.appendChild(css);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queue,{once:true});else queue();
  var observer=new MutationObserver(function(records){
    for(var i=0;i<records.length;i++){
      if(records[i].addedNodes&&records[i].addedNodes.length){queue();return}
    }
  });
  observer.observe(document.body||document.documentElement,{childList:true,subtree:true});
})();